import type { FC } from 'react';
import { lazy } from 'react';
import type { AggregateEuRootRequest } from 'src/apis/aggregate-eu/use-aggregate-eu-root';
import type { Successful } from 'src/hooks/use-axios';

const OverviewPage = lazy(() => import('./page'));

type Props = {
  aggregateEuRootRequest: Successful<AggregateEuRootRequest>;
};

export const AggregateEuOverview: FC<Props> = ({ aggregateEuRootRequest }) => {
  return <OverviewPage aggregateEuRootRequest={aggregateEuRootRequest} />;
};
